<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    max-width="500px"
    :fullscreen="this.$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-toolbar flat tile class="flex-grow-0">
        <v-toolbar-title class="title">
          {{ $t("cancelPaidBetTitle") }}
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="showDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="px-8 py-4">
        <span class="overline font-weight-bold">{{ $t("attention") }}</span>
        <br />
        <p class="body-2 pb-0 mb-2">
          {{ $t("cancelPaidBetContent1") }}
        </p>
        <p class="body-2 pa-0 mt-2">
          {{ $t("cancelPaidBetContent2") }}
        </p>
        <p class="body-2 pa-0 mt-2">
          {{ $t("actionCantBeUndone") }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="showDialog = false">
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn color="primary" text @click="confirm">
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["dialog", "dialogClosed", "confirmBetCancel"],
  data: () => ({
    showDialog: false,
  }),
  created() {
    this.showDialog = this.dialog;
  },
  watch: {
    dialog(dialog) {
      this.showDialog = dialog;
    },
    showDialog(dialog) {
      if (!dialog) {
        this.$emit("dialogClosed");
      }
    },
  },
  methods: {
    confirm() {
      this.$emit("confirmBetCancel");
    },
  },
};
</script>
